/**
 * Google's attribution next to the address suggestions, which are shown without a Google map.
 *
 * Google Maps Platform, Places API policies (developers.google.com/maps/documentation/places/web-service/policies,
 * «Google Maps attribution»): the Google Maps logo «whenever possible»; where the interface cannot
 * hold it, the text «Google Maps» — Roboto or a sans-serif fallback, weight 400, normal spacing,
 * 12–16 sp, black (#1F1F1F), gray (#5E5E5E) or white with at least 4.5:1 contrast, never
 * re-capitalised, wrapped or translated (`translate="no"`), within the same container as the
 * content. This is the text form; the logo file is a follow-up (#958).
 */
export function GoogleAttribution() {
  return (
    <span
      translate="no"
      lang="en"
      className="shrink-0 text-[12px] leading-none font-normal tracking-normal whitespace-nowrap text-[#5e5e5e] dark:text-white"
      style={{ fontFamily: 'Roboto, Arial, sans-serif' }}
    >
      Google Maps
    </span>
  );
}
